import types from './types';
import { createTrendsReducer } from '../../common/trends/reducers';

const { reducer, initialState } = createTrendsReducer(types);

export default reducer;
export { initialState };
